import React from 'react';
import {Avatar, Button, Dropdown, Space, Tag} from 'antd';
import {LoginOutlined, LogoutOutlined, QuestionCircleOutlined, SettingOutlined, UserOutlined} from '@ant-design/icons';

function UserMenu({
  isAuthenticated,
  user,
  isGuest: isGuestProp,
  onLoginClick,
  onProfileClick,
  onLogout,
  onSettingsClick,
  onHelpClick,
}) {
  const noop = () => {};
  const guestDetected = isGuestProp || user?.lgnUserNm === 'guest' || user?.userNm === 'guest';
  const handleHelp = onHelpClick || noop;
  const handleSettings = onSettingsClick || noop;
  const handleLogout = onLogout || noop;

  // 게스트 전용 (dropdown 대신 단순 표시 + 로그인 버튼)
  if (guestDetected) {
    return (
      <Space>
        <Tag color="orange" style={{ margin: 0 }}>GUEST</Tag>
        <Button type="primary" icon={<LoginOutlined />} onClick={onLoginClick}>로그인</Button>
      </Space>
    );
  }

  const items = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '프로필',
      onClick: () => (onProfileClick ? onProfileClick() : noop())
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '설정',
      onClick: () => handleSettings()
    },
    { type: 'divider' },
    {
      key: 'help',
      icon: <QuestionCircleOutlined />,
      label: '도움말',
      onClick: () => handleHelp()
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '로그아웃',
      onClick: () => {
        if (window.confirm('로그아웃하시겠습니까?')) {
          handleLogout();
        }
      }
    }
  ];

  // 비로그인 상태 (게스트 아님)
  if (!isAuthenticated) {
    return <Button type="primary" icon={<LoginOutlined />} onClick={onLoginClick}>로그인</Button>;
  }

  const displayName = user?.userNm || user?.lgnUserNm || '사용자';
  const avatarSrc = user?.profileUrl || user?.avatar;

  return (
    <Dropdown menu={{ items }} placement="bottomRight" arrow trigger={['click']}>
      <div style={{ cursor: 'pointer' }}>
        <Space>
          <Avatar
            icon={<UserOutlined />}
            src={avatarSrc}
            style={{ backgroundColor: '#1890ff', border: '3px solid #1890ff' }}
            size={36}
          />
            <span style={{ color: '#1890ff', fontWeight: 'bold', fontSize: 14 }}>
              {displayName}
            </span>
        </Space>
      </div>
    </Dropdown>
  );
}

export default UserMenu;
